import axios from 'axios';
import {BusinessData} from "../../entities";
import { useNotification   } from "@kyvg/vue3-notification";
const TOOLTIPS_PARAM = 'TOOLTIPS_PARAM';
const notification = useNotification()
export default {
    data: function () {
        return {
            showPreloader: false,
            emptyList: [{'id': '', 'text': ''}],
            pageConfig: {},
            applicationDefaults: [],
            phone_cache: {},
        };
    },
    beforeCreate: function () {
        // objCommon.generalPreloader.show_pl($('.alert.alert-confirmation'), true, false, LANGUAGE['processing']);
    },
    created: function () {
    },
    mounted: function () {
        this.fixHeaderScroll();
        objCommon.generalPreloader.hide_pl();
        var objDropdownSmenu = $('.dropdown-submenu');
        objDropdownSmenu.children('a').on('click', function (e) {
            //preventing to default browser behaviors when user click separators in topmenu
            e.preventDefault();
            //preventing to default bootstrap behaviors when user click separators in topmenu
            e.stopPropagation();
        });
        objDropdownSmenu.on({
            mouseenter: function () {
//                var objThs = $(this);
//                        objGrandParent = objThs.parent().parent();
                $(this).addClass('subOpened');
//                if(objGrandParent.is('dropdown-submenu')){
//                    objGrandParent.children('a').addClass('subOpened');
//                }
            },
            mouseleave: function () {
                $(this).removeClass('subOpened');
            }
        });

        if (!!this.pageConfig && Object.values(this.pageConfig).length > 0) {
            this.runPageConfig(this.pageConfig);
        }

    },
    computed: {},
    methods: {
        //jQuery common.js quick fix
        fixHeaderScroll() {
            if (typeof objCommon !== "undefined") {
                objCommon.objTitleHeader = $('.titleHeader').last()
                objCommon.objHeaderCopy = $('.headerCopy');
                objCommon.objHeaderCopyIn = $('.headerCopyIn');
                objCommon.headerCopying();
            }
        },
        validate(selector, ignore_hidden = false, scroll = true) {
            const $block = $(selector);
            const $elements = $block.find('input, select, textarea');
            if ($elements.length > 0) {
                const isValid = $elements.valid();
                if (!isValid) {
                    const $errorElement = $('.form-group.has-error').first()
                    const $collapse = $errorElement.closest('.collapse');
                    if ($collapse.length > 0) {
                        $collapse.collapse('show');
                    }

                    if (scroll) {
                        $('html, body').animate({
                            scrollTop: ($errorElement.first().offset().top - 50)
                        })
                    }

                }
                return isValid;
            } else {
                return true;
            }
        },
        validator(name) {
            return {
                assertTrue: (value, message) => {
                    // cast to boolean
                    this.assert(!!value, true, message, name);
                }
            }
        },
        assert(value, expect, message, title) {
            if (!title) {
                title = this.lang('validation_error');//'Validation Error';
            }
            if (value !== expect) {
                this.notifyError(title, message);
                throw message;
            }
        },
        formatFrequency(frequency) {
            if (frequency === 'weekly') {
                return this.lang('weekly');
            } else if (frequency === 'daily') {
                return this.lang('daily');
            } else {
                return '??';
            }
        },
        formatSelectType: function (param, data, key) {
            param = Object.assign({}, param);
            if (!!param) {
                const parameter = param.hasOwnProperty(key) ? param[key].find((obj) => {
                    return obj.id === data
                }) : '-';
                return !!parameter && parameter.hasOwnProperty('text') ? parameter.text : '-';
            }
            return '-';
        },
        formatOptionType: function (param, data, key) {
            if (!!param) {
                const parameter = param.hasOwnProperty(key) ? param[key].find((obj) => {
                    return obj.value === data
                }) : '-';
                return !!parameter && parameter.hasOwnProperty('label') ? parameter.label : '-';
            }
            return '-';
        },
        formatBooleanOption: function (data) {
            let vm = this;
            return this.formatOptionType(vm.parameters, data, 'YES_NO_OPTIONS');
        },
        formatMoney: function (data) {
            return '£' + data;
        },
        formatPercent: function (data) {
            return data + '%';
        },
        formatPhoneCode: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'PHONE_CODES')
            }
            return '-';
        },
        formatDateSlashes: function (param, data, key) {
            let regex = /[/]/g;
            if (!!param) {
                const parameter = param.hasOwnProperty(key) ? param[key].find((obj) => {
                    return obj.value === data
                }) : '-';
                return !!parameter && parameter.hasOwnProperty('label') ? parameter.label : '-';
            }
            return data.replace(regex, '-');
        },
        formatAlliancePartnerDate: function (param, data, formatter, source_format = 'ddmmyyyy') {
            if (param) {
                if (formatter === source_format) {
                    return data;
                }
                let date = data.split("-");
                let formatted_date = date;
                // format the date from source_format to ddmmyyyy format
                if (source_format === 'mmddyyyy') {
                    formatted_date = [date[1], date[0], date[2]];
                }
                else if (source_format === 'yyyymmdd' ) {
                    formatted_date = [date[2], date[1], date[0]];
                }

                if (formatter === 'yyyymmdd') {
                    formatted_date = [date[2], date[1], date[0]];
                }
                else if (formatter === 'mmddyyyy') {
                    formatted_date = [date[1], date[0], date[2]];
                }
                return formatted_date.join('-')
            }
            return '-';
        },
        showErrorTooltip($element) {
            let vm = this;
            setTimeout(function () {

                if ($element.find(':radio, :checkbox').length) {
                    $element.find('label').filter(':visible').first().tooltip('show');
                } else {
                    $element.find('input, select, textarea').not(vm.ignored).tooltip('show')
                }
            }, 150);
        },
        formatViewValueMultiSelect: function (data, param) {
            let options = [];
            let select_values = [];
            if (typeof data === 'string') {
                select_values = data.split(",");
            }
            else if (Array.isArray(data)) {
                select_values = data;
            }
            else {
                return '-';
            }
            select_values.forEach(
                (select_value) => {
                    let item_text = '-';
                    if (Array.isArray(param)) { //id property of each item is the key field of the array
                        const item = param.find((obj) => { return obj.id === select_value && obj.id !== ''});
                        item_text = !!item && item.hasOwnProperty('text') ? item.text : '-';
                    }
                    else {  // Object. parameter data is the key to get the value (item)
                        const item = param[select_value];
                        item_text =  !!item && item.hasOwnProperty('text') ? item.text : '-';
                    }
                    if (item_text !== '-') {
                        options.push(item_text);
                    }
                }
            );
            return (options.length > 0) ? options.join(', ') : '-';
        },
        // runPageConfig(pageConfig) {
        //     let pageObject = this;
        //     let removeElement = (element) => {
        //         if (!!pageObject.$refs[element.id]) {
        //             if (element.attribute.type === 'field' || element.attribute.type === 'phone' || element.attribute.type === 'sub_block') {
        //                 let DOMElement;
        //                 DOMElement = pageObject.$refs[element.id]['$el'];
        //                 if (!!DOMElement) {
        //                     DOMElement.remove();
        //                 } else {
        //                     pageObject.$refs[element.id].remove();
        //                 }
        //
        //
        //             } else if (element.attribute.type === 'array_field' || element.attribute.type === 'phone_array_field' ) {
        //                 let DOMElements = pageObject.$refs[element.id];
        //                 DOMElements.forEach(function (obj) {
        //                     let DOMElement = obj['$el'];
        //                     if (!!DOMElement) {
        //                         DOMElement.remove();
        //                     } else {
        //                         obj.remove();
        //                     }
        //                 });
        //             } else {
        //                 let DOMElement;
        //                 DOMElement = pageObject.$refs[element.id];
        //                 if (!!DOMElement) {
        //                     DOMElement.remove();
        //                 }
        //             }
        //         }
        //     };
        //
        //     let blockRender = (block) => {
        //         let pageObject = this;
        //         let elements = (block.hasOwnProperty('elements') && !!block.elements) ? Object.values(block.elements) : [];
        //
        //         elements.forEach(element => {
        //             const is_required = (!!element.attribute.is_required && (element.attribute.is_required === 'Y' || element.attribute.is_required === 'M'));
        //
        //             if (element.attribute.type === 'field') {
        //                 if (element.attribute.selected === 'Y') {
        //                     if (!!pageObject.$refs[element.id]) {
        //                         let DOMElementComp = pageObject.$refs[element.id];
        //                         DOMElementComp.page_config_required = is_required;
        //                     }
        //                 } else {
        //                     removeElement(element);
        //                 }
        //             }
        //             else if (element.attribute.type === 'phone') {
        //                 if (element.attribute.selected === 'Y') {
        //                     if (!!pageObject.$refs[element.id]) {
        //                         let phoneCode = pageObject.$refs[element.id + '_code'];
        //                         let phoneNumber = pageObject.$refs[element.id + '_no'];
        //                         if(!!phoneCode) {
        //                             phoneCode.page_config_required = is_required;
        //                         }
        //                         if(!!phoneNumber) {
        //                             phoneNumber.page_config_required = is_required;
        //                         }
        //                     }
        //                 } else {
        //                     removeElement(element);
        //                 }
        //             }
        //             else if (element.attribute.type === 'array_field' || element.attribute.type === 'phone_array_field') {
        //                 if (element.attribute.selected === 'Y') {
        //                     if (!!pageObject.$refs[element.id]) {
        //                         let arrayFields = pageObject.$refs[element.id];
        //                         if(element.attribute.type === 'phone_array_field') {
        //                             arrayFields.forEach(function(ref, index) {
        //                                 let phoneCode = pageObject.$refs[element.id + '_code'][index];
        //                                 let phoneNumber = pageObject.$refs[element.id + '_no'][index];
        //                                 if(!!phoneCode) {
        //                                     phoneCode.page_config_required = is_required;
        //                                 }
        //                                 if(!!phoneNumber) {
        //                                     phoneNumber.page_config_required = is_required;
        //                                 }
        //                             })
        //                         } else {
        //                             arrayFields.forEach(function(ref) {
        //                                 ref.page_config_required = is_required;
        //                             })
        //                         }
        //                     }
        //                 } else {
        //                     removeElement(element);
        //                 }
        //             } else if (element.attribute.type === 'sub_block') {
        //                 if (element.attribute.selected === 'Y') {
        //                     blockRender(element);
        //                 } else {
        //                     removeElement(element)
        //                 }
        //             }
        //         });
        //     };
        //
        //     let blocksRender = (pageConfig) => {
        //         let blocks = pageConfig.hasOwnProperty('blocks') ? Object.values(pageConfig.blocks) : [];
        //         blocks.forEach(block => {
        //             if (block.attribute.selected === 'Y') {
        //                 blockRender(block);
        //             } else {
        //                 removeElement(block);
        //             }
        //         });
        //     };
        //
        //     blocksRender(pageConfig);
        // },
        notifyError(title, text) {
            if(text === undefined) {
                text = '';
            }
            if(title === undefined || title === '') {
                title = 'Error';
            }
            if(notification.notify) {
                notification.notify({
                    title: title,
                    text: text,
                    type: 'error',
                    duration: 7000,
                    closeOnClick:true,
                    dangerouslySetInnerHtml:true
                });
            } else if (typeof objCommon !== "undefined") {
                objCommon.showCustomValidationError(title + ' ' + text);
            }
        },
        notifyInfo(title, text) {
            if(notification.notify) {
                notification.notify({
                    title: title,
                    text: text,
                    type: 'info',
                    duration: 7000,
                    closeOnClick:true
                });
            } else if (typeof objCommon !== "undefined") {
                objCommon.showCustomValidationError(title + ' ' + text);
            }
        },
        notifySuccess(text) {
            let vm = this;
            if(notification.notify) {
                notification.notify({
                    title: vm.lang('success'),
                    text: text,
                    type: 'success',
                    duration: 7000,
                    closeOnClick:true
                });
            } else if (typeof objCommon !== "undefined") {
                objCommon.showCustomSuccessMessage(text);
            }
        },

        getAxiosInstance() {
            if (!!this.showPreloader) {
                objCommon.generalPreloader.show_pl($('.main_contentContainer'), false, false, LANGUAGE['processing']);
            }
            const instance = axios.create({
                headers: {'X-Requested-With': 'XMLHttpRequest'},
            });
            const vm = this;
            instance.interceptors.response.use(function(response) {
                if (response.headers['x-csrf-token']) {
                    let token = response.headers['x-csrf-token'].split(';');
                    objCommon.setNewCSRF(token[0], token[1], token[2]);
                }
                const data = response.data;
                if (data.result === 'ERROR') {
                    vm.notifyError('API Error', data.error.explanation)
                    // return Promise.reject(response);
                }
                objCommon.generalPreloader.hide_pl();
                return response;
            }, function (error) {
                if (!!error && !!(error.response) && !!(error.response.headers) && error.response.headers['x-csrf-token']) {
                    let token = error.response.headers['x-csrf-token'].split(';');
                    objCommon.setNewCSRF(token[0], token[1], token[2]);
                }
                // if (error.response.status === 401) {
                //     if (typeof objCommon !== "undefined") {
                //         // objCommon.showCustomValidationError('401 Unauthorised: Session Expired');
                //         vm.notifyError('Error', '401 Unauthorised: Session Expired')
                //     }
                //     setTimeout(function() {
                //         window.location.href = '/login';
                //     }, 500);
                // } else if (error.response.status === 403) {
                //     if (typeof objCommon !== "undefined") {
                //         // objCommon.showCustomValidationError(`403 Forbidden: Permission denied on endpoint ${error.response.request.responseURL}`);
                //         vm.notifyError('403 Forbidden', `Permission denied on endpoint ${error.response.request.responseURL}`);
                //     }
                // } else {
                //     if (typeof objCommon !== "undefined") {
                //         // objCommon.showCustomValidationError(`Unexpected error`);
                //         vm.notifyError('Unexpected error', `Unknown error`);
                //     }
                //     //console.log('Error');
                // }
                vm.handleAjaxError(error);
                return Promise.reject(error);
            });
            return instance;
        },
        handleAjaxError: function(error, custom_error = '') {
            let vm = this;
            if (!error || !error.hasOwnProperty('response') || !error.response.hasOwnProperty('status')) {
                console.log('Error');
                return;
            }

            if (error.response.status === 401) {
                if (typeof objCommon !== "undefined") {
                    objCommon.showCustomValidationError('ajax_error_msg_session');
                }
                setTimeout(function () {
                    window.location.href = '/login';
                }, 500);
            } else if (error.response.status === 403) {
                if (typeof objCommon !== "undefined") {
                    objCommon.showCustomValidationError(`ajax_error_msg_csrf`);
                }
            } else {
                if (typeof objCommon !== "undefined") {
                    objCommon.showCustomValidationError(custom_error !== '' ? vm.lang('an_error_has_occured') : vm.lang(custom_error));
                }
                console.log('Error');
            }
        },
        setApplicationSave: function () {
            $('body .saveAnywayForm #save_anyway').val(1);
        },
        formatDecimal(item, key) {
            if (!!item.charge_decimals && !!item[key]) {
                var fractionDigits = parseInt(item.charge_decimals) || 2;
                let formattedValue = parseFloat(item[key]).toFixed(fractionDigits);
                if (!isNaN(formattedValue)) {
                    this.$set(item, key, formattedValue);
                }
            }
        },
        convertToDecimal(value, decimal = 2) {
            value = parseFloat(value);
            if (!isNaN(value)) {
                return value.toFixed(decimal);
            }
            return '0';
        },
        countDecimals: function (value) {
            value = parseFloat(value);
            if (value % 1 > 0) {
                return value.toString().split(".")[1].length || 0;
            }
            return 0
        },
        Ucwords: function (text) {
            if (!!text && text.length > 0) {
                let lowcase = text.toLowerCase();
                return lowcase.charAt(0).toUpperCase() + lowcase.slice(1);
            }
            return '-';
        },
        objectIsNotEmpty: function (object) {
            for (var property in object) {
                if (object.hasOwnProperty(property)) {
                    return true;
                }
                else {
                    return false;
                }
            }
        },
        jsonCopy: function (src) {
            return JSON.parse(JSON.stringify(src));
        },
        npPropertyExistAndIsArray: function (object, property) {
            return (!!object && object.hasOwnProperty(property) && Array.isArray(object[property]));
        },
        setBankDefaults: function (dataObject, bank_type, domain, appDefaults = []) {
            let vm = this;

            if (appDefaults.length === 0){
                appDefaults = !!this.applicationDefaults ? this.applicationDefaults : [];
            }

            let bankPageConfigHasField = (field_name, field_bank_type) => {
                return vm.pageConfigHasField(field_bank_type +'_'+field_name) //concat the bank type to the field for page config check i.e debit_settlement_method
            }

            appDefaults.forEach(app_field => {
                if((app_field.entity_block == domain) || (domain == 'MAIN_OUTLET' && app_field.entity_block == 'ALL_OUTLET') ){
                    let field_name = !!app_field.field_name ? app_field.field_name : '',
                        def_value = !!app_field.selfboarding_default_value ? !isNaN(app_field.selfboarding_default_value) ? String(app_field.selfboarding_default_value) : app_field.selfboarding_default_value : '';
                    if (bankPageConfigHasField(field_name, bank_type) && dataObject.hasOwnProperty(field_name)) {
                        if(dataObject[field_name] == '' || (!!app_field.selfboarding_readonly && app_field.selfboarding_readonly == '1')) {
                            dataObject[field_name] = def_value;
                        }
                        let element = vm.$refs[field_name];
                        if(!!element && !!app_field.readonly && app_field.readonly == '1') {
                            element.default_readonly = true;
                        }
                    }
                    else {
                        // TODO: Else scenario, set value of existing input to default
                        let elementForm = $('form');
                        let elementField = elementForm.length > 0 ? $('form').find('[name*="' + field_name + '"]') : [];
                        if (elementForm.length > 0 && elementField.length === 0) {
                            let inputField = '<input type="hidden" id="' + field_name + '" name="' + field_name + '" value="' + def_value + '" />'
                            elementForm.prepend(inputField);
                        }
                    }
                }
            });
            let save_anyway = $('#save_anyway');
            if(!!save_anyway && save_anyway.length > 0) {
                save_anyway.val(1);
            }
        },
        setApplicationDefaults: function (dataObject, domain, appDefaults = []) {
            let vm = this;

            if (appDefaults.length === 0){
                appDefaults = !!this.applicationDefaults ? this.applicationDefaults : [];
            }

            appDefaults.forEach(app_field => {
                if((app_field.entity_block == domain) || (domain == 'MAIN_OUTLET' && app_field.entity_block == 'ALL_OUTLET') ){
                    let field_name = !!app_field.field_name ? app_field.field_name : '',
                        def_value = !!app_field.selfboarding_default_value ? !isNaN(app_field.selfboarding_default_value) ? String(app_field.selfboarding_default_value) : app_field.selfboarding_default_value : '';
                    if (vm.pageConfigHasField(field_name) && dataObject.hasOwnProperty(field_name)) {
                        if(dataObject[field_name] == '' || (!!app_field.selfboarding_readonly && app_field.selfboarding_readonly == '1')) {
                            dataObject[field_name] = def_value;
                        }
                        let element = vm.$refs[field_name];
                        if(!!element && !!app_field.selfboarding_readonly && app_field.selfboarding_readonly == '1') {
                            element.default_readonly = true;
                        }
                    }
                    else {
                        // TODO: Else scenario, set value of existing input to default
                        let elementForm = $('form');
                        let elementField = elementForm.length > 0 ? $('form').find('[name*="' + field_name + '"]') : [];
                        if (elementForm.length > 0 && elementField.length === 0) {
                            let inputField = '<input type="hidden" id="' + field_name + '" name="' + field_name + '" value="' + def_value + '" />'
                            elementForm.prepend(inputField);
                        }
                    }
                }
            });
            let save_anyway = $('#save_anyway');
            if(!!save_anyway && save_anyway.length > 0) {
                save_anyway.val(1);
            }
        },
        appDefaultReadonly: function (app_field_name) {
            try {
                let appDefaults = !!this.applicationDefaults ? this.applicationDefaults : [];
                appDefaults.forEach(app_field => {
                    let field_name = !!app_field.field_name ? app_field.field_name : '';
                    if (app_field_name === field_name) {
                        throw app_field;
                    }
                });
            }
            catch (e) {
                if (!!e.readonly && e.readonly == '1') {
                    return true
                } else {
                    return false
                }
            }
            return false
        },
        pageConfigHasField: function (field) {
            let pageBlocks = !!this.pageConfig ? this.pageConfig.blocks : {}

            const recursiveFindElement = (field_name, elements) => {
                for (let element in elements) {
                    if (elements.hasOwnProperty(element)) {
                        if (elements[element].id == field_name) {
                            return true
                        } else if (elements[element].attribute.type == 'sub_block') {
                            //.get the elements in the sub block
                            let sub_block_elements = !!elements[element].elements ? elements[element].elements : {}
                            if(recursiveFindElement(field_name, sub_block_elements)){
                                return true;
                            }
                        }
                    }
                }
            }

            for (let block in pageBlocks) {
                if (pageBlocks.hasOwnProperty(block)) {
                    let elements = !!pageBlocks[block].elements ? pageBlocks[block].elements : {}

                    if (recursiveFindElement(field, elements)){
                        return true;
                    }
                    // for (let element in elements) {
                    //     if (elements.hasOwnProperty(element)) {
                    //         if (elements[element].id == field) {
                    //             return true
                    //         }
                    //     }
                    // }
                }
            }
            return false
        },
        setDependantFields: function(dependantFields, is_required) {
            let vm = this;
            let setRequired = function (element) {
                if(!!vm.$refs[element]) {
                    vm.$refs[element]['page_config_required'] = is_required;
                }
            };

            if(Array.isArray(dependantFields)) {
                dependantFields.forEach(function (field) {
                    setRequired(field);
                });
            } else {
                setRequired(dependantFields);
            }
        },
        countCharacters: function (val){
            if (!!val.toString().trim()){
                return val.toString().trim().length
            }
            return 0
        },
        getTooltipText: function (tooltip_key_reference, original_hardcode_tooltip=null) {
            let vm = this,
                has_param = vm.parameters && vm.parameters.hasOwnProperty(TOOLTIPS_PARAM),
                tooltips_params_list = (has_param && vm.parameters[TOOLTIPS_PARAM].hasOwnProperty('tooltips')) ?
                    vm.parameters[TOOLTIPS_PARAM]['tooltips'] : null,
                tooltipObj = has_param && tooltips_params_list ? tooltips_params_list.find(tooltip => {
                    let has_tooltip_key_reference = tooltip.hasOwnProperty('tooltip_key_reference');
                    return has_tooltip_key_reference && tooltip.tooltip_key_reference === tooltip_key_reference;
                }) : null,
                tooltip = tooltipObj && tooltipObj.hasOwnProperty('tooltip_help_text') ?
                    tooltipObj.tooltip_help_text : this.textLangKeyValueThenEmpty(tooltip_key_reference,original_hardcode_tooltip);

            return tooltip;
        },
        getGeneralInfoText: function (tooltip_key_reference) {
            let vm = this,
                has_param = vm.parameters && vm.parameters.hasOwnProperty(TOOLTIPS_PARAM),
                tooltips_params_list = (has_param && vm.parameters[TOOLTIPS_PARAM].hasOwnProperty('general_info')) ?
                    vm.parameters[TOOLTIPS_PARAM]['general_info'] : null,
                tooltipObj = has_param && tooltips_params_list ? tooltips_params_list.find(tooltip => {
                    let has_tooltip_key_reference = tooltip.hasOwnProperty('tooltip_key_reference');
                    return has_tooltip_key_reference && tooltip.tooltip_key_reference === tooltip_key_reference;
                }) : null,
                tooltip = tooltipObj && tooltipObj.hasOwnProperty('tooltip_help_text') ?
                    tooltipObj.tooltip_help_text : this.textLangKeyValueThenEmpty(tooltip_key_reference);

            return tooltip;
        },
    }
}